import type { TPlayer } from '@setplex/pureya'
// import { mq, PLAYER } from '~/shared/mq'

export type Intent = (typeof Intent)[keyof typeof Intent]
export const Intent = {
  OpenPlayer: 'open-player',
  ClosePlayer: 'close-player',
  AutoPreview: 'auto-preview',
  TrailerHiddenByScroll: 'trailer-hidden-by-scroll',
  TrailerVisibleByScroll: 'trailer-visible-by-scroll',
  OtherContent: 'other-content',
  UserExit: 'user-exit',
  SelectEpisodeFromPlaylist: 'select-episode-from-playlist',
  SelectChannelFromEpg: 'select-channel-from-epg',
} as const

export class PlayerIntentMessage {
  static readonly topic = 'app/player/intent'
  public player: TPlayer | undefined
  public intent: Intent

  constructor(player: TPlayer | undefined, intent: Intent) {
    this.player = player
    this.intent = intent
  }
}
